import React, { VFC } from 'react';
import AppLayout from '../../../front/Layout/AppLayout';
import {
  HeaderProps,
  BusinessProps,
  PlanProps,
} from '~/src/feature/toyono/types';
import Top from '~/src/feature/toyono/components/Top';
import About from '~/src/feature/toyono/components/About';
import Plan from '~/src/feature/toyono/components/Plan';
import Access from '~/src/feature/toyono/components/Access';
import Partner from '~/src/feature/toyono/components/Partner';
import styled from 'styled-components';
import { TEXT_COLOR, BACKGROUND_COLOR } from '~/src/feature/toyono/constants';
import { Theme, useTheme } from '@material-ui/core/styles';

const TopContainer = styled.div<{ theme: Theme }>`
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing(4, 2)};
  color: ${TEXT_COLOR};
  position: relative;
  ${({ theme }) => theme.breakpoints.up('md')} {
    &:after {
      position: absolute;
      width: 100%;
      background: ${BACKGROUND_COLOR};
      height: 35%;
      bottom: 0;
      right: 0;
      content: '';
      z-index: -1;
    },
  }
`;

const Container = styled.div<{ theme: Theme }>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing(4, 2)};
`;

const MiddleContainer = styled(Container)`
  background: ${BACKGROUND_COLOR};
`;

interface Props {
  authenticated: boolean;
  businesses: Array<BusinessProps>;
  plans: Array<PlanProps>;
  headerProps: HeaderProps;
}

const ToyonoComponent: VFC<Props> = ({
  authenticated,
  businesses,
  plans,
  headerProps,
}: Props) => {
  const theme = useTheme();

  return (
    <AppLayout authenticated={authenticated} {...headerProps}>
      <TopContainer theme={theme}>
        <Top />
      </TopContainer>
      <MiddleContainer theme={theme}>
        <About />
        <Plan
          businesses={businesses}
          plans={plans}
          authenticated={authenticated}
        />
      </MiddleContainer>
      <Container theme={theme}>
        <Access />
        <Partner />
      </Container>
    </AppLayout>
  );
};

export default ToyonoComponent;
